import React from "react";
import { useHistory } from "react-router-dom";
import * as S from "./styles";
import CTAButton from "../CTAButton";

const Error404 = ({ message, ...props }) => {
  let history = useHistory();
  return (
    <S.Wrapper>
      <S.Title>Ops!</S.Title>
      <S.ErrorDescription>
        {message || "Página não encontrada."}
      </S.ErrorDescription>
      <CTAButton
        text="Volte a navegação"
        onClick={() => history.push("/explore")}
      />
    </S.Wrapper>
  );
};

export default Error404;
